const replaceAll = (str, match, replacer) => {
  const regex = new RegExp(match, 'g');

  return str.replace(regex, replacer);
};

export default replaceAll;
